import axios from 'axios';

const API_BASE_URL = 'https://whatsappproapi.defconinnovations.com';

const getAuthHeaders = () => {
  const auth = JSON.parse(localStorage.getItem('auth'));
  const token = auth?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

const apiService = {
  get: async (url, config = {}) =>
    apiClient
      .get(url, {
        ...config,
        headers: { ...getAuthHeaders(), ...config.headers },
      })
      .then(res => res.data),

  post: async (url, data = {}, config = {}) =>
    apiClient
      .post(url, data, {
        ...config,
        headers: { ...getAuthHeaders(), ...config.headers },
      })
      .then(res => res.data),

  put: async (url, data = {}, config = {}) =>
    apiClient
      .put(url, data, {
        ...config,
        headers: { ...getAuthHeaders(), ...config.headers },
      })
      .then(res => res.data),

  patch: async (url, data = {}, config = {}) =>
    apiClient
      .patch(url, data, {
        ...config,
        headers: { ...getAuthHeaders(), ...config.headers },
      })
      .then(res => res.data),

  delete: async (url, config = {}) =>
    apiClient
      .delete(url, {
        ...config,
        headers: { ...getAuthHeaders(), ...config.headers },
      })
      .then(res => res.data),
};

export default apiService;